var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhitetelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_902",
    "data-name": "Group 902",
    transform: "translate(-2965 -6590)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1058",
    "data-name": "Rectangle 1058",
    width: 24,
    height: 24,
    transform: "translate(2965 6590)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer_2",
    d: "M23.481,11.622c-2.9,1.2-15.332,6.351-18.767,7.754-2.3.9-.955,1.742-.955,1.742s1.967.674,3.652,1.18A3.3,3.3,0,0,0,10,22.242L17.918,16.9c2.809-1.91,2.135-.337,1.461.337-1.461,1.461-3.877,3.765-5.9,5.619a1.064,1.064,0,0,0-.056,1.8c1.461,1.236,5.45,3.765,5.675,3.933,1.187.84,3.522,2.05,3.877-.506l1.4-8.822c.45-2.978.9-5.731.955-6.518C25.5,10.835,23.481,11.622,23.481,11.622Z",
    transform: "translate(2962.645 6581.457)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhitetelegram);
export default __webpack_public_path__ + "static/media/whitetelegram.79f515ed6da364f78b4fcda824f94778.svg";
export { ForwardRef as ReactComponent };